var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useEffect, useState } from 'react';
import { Layout, Row, Spin, Card, Col } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { ViolationType } from '@tenderd/telematics-client';
import { DateRangeFilter, HEREMap, useService, useTimezone, } from '@tenderd/track-web-utils';
import { useGroupService } from '../../providers/GroupServiceProvider';
import './GroupAnalyticsPage.css';
import { NoPermissionView } from '../../components/NoPermissionView/NoPermissionView';
import { GroupPermission, useGroupPermissions, } from '../../providers/useGroupPermissions';
import { BreakdownByOutcomeCard, IdlingMachinesCard, MachineByIgnitionTurnedOnCard, MachineByTypeCard, OvertimeStatsCard, ProjectStatisticsCard, RecentEventsCard, TotalViolationsByTypeCard, ViolationAndMachineTypeAnalyticsCard, ViolationsStatisticsCard, } from './components/AnalyticsCards';
import LiveStatusCard from './components/AnalyticsCards/LiveStatusCard';
import useGetDevices from '../../providers/useGetDevices';
import IdlingHeatMapCard from './components/AnalyticsCards/IdlingHeatMapCard';
var Content = Layout.Content;
export var getStatusLabel = function (status) {
    var label = status + '';
    label = label.charAt(0).toUpperCase() + label.slice(1);
    return label;
};
export var generateTooltip = function (title, items) {
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", { style: { paddingLeft: 0 } }, items === null || items === void 0 ? void 0 : items.map(function (item, index) {
            var name = item.name, color = item.color;
            return (React.createElement(React.Fragment, { key: item.year },
                React.createElement("li", { className: "g2-tooltip-list-item", "data-index": index, style: {
                        marginBottom: 4,
                        display: 'flex',
                        alignItems: 'center',
                    } },
                    React.createElement("span", { className: "g2-tooltip-marker", style: { backgroundColor: color } }),
                    React.createElement("span", { style: {
                            display: 'inline-flex',
                            flex: 1,
                            justifyContent: 'space-between',
                        } },
                        React.createElement("span", { style: { marginRight: '16' } }, name))),
                React.createElement("ul", null,
                    React.createElement("div", { style: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        } },
                        React.createElement(Spin, { style: { margin: '0px' }, indicator: React.createElement(LoadingOutlined, { style: { fontSize: 13 }, spin: true }) }),
                        React.createElement("p", { style: {
                                marginLeft: '5px',
                                marginTop: '3px',
                            } },
                            "Loading projects...",
                            ' ')))));
        }))));
};
var GroupAnalyticsPage = function (props) {
    var dayjs = useTimezone().dayjs;
    var _a = __read(useState([]), 2), mchinesDataByIgnitionOn = _a[0], setMchinesDataByIgnitionOn = _a[1];
    var _b = __read(useState([]), 2), idlingMachinesData = _b[0], setIdlingMachinesData = _b[1];
    var _c = __read(useState([]), 2), violationsStatistics = _c[0], setViolationsStatistics = _c[1];
    var _d = __read(useState([]), 2), totalViolations = _d[0], setTotalViolations = _d[1];
    var _e = __read(useState({}), 2), equipments = _e[0], setEquipments = _e[1];
    var _f = __read(useState([]), 2), matrixTableData = _f[0], setMatrixTableData = _f[1];
    var _g = __read(useState([]), 2), overTimeTableData = _g[0], setOverTimeTableData = _g[1];
    var _h = __read(useState(), 2), analyticsData = _h[0], setAnalyticsData = _h[1];
    var _j = __read(useState(), 2), idlingHeatmapData = _j[0], setIdlingHeatmapData = _j[1];
    var groupService = useGroupService();
    var service = useService();
    var _k = __read(useState(true), 2), analyticsLoading = _k[0], setAnalyticsLoading = _k[1];
    var _l = useGetDevices({}), devices = _l.devices, equipmentLoading = _l.loading, getData = _l.getData, devicesTotalCount = _l.devicesTotalCount;
    var loading = equipmentLoading || analyticsLoading;
    var _m = __read(useState(true), 2), heatmapLoading = _m[0], setHeatmapLoading = _m[1];
    var _o = __read(useState([
        dayjs().tz().add(-1, 'day').startOf('day'),
        dayjs().tz().add(-1, 'days').endOf('day'),
    ]), 2), dates = _o[0], setDates = _o[1];
    useEffect(function () {
        if (!devices || !devices.length)
            return;
        setEquipments(devices.reduce(function (acc, curr) {
            acc[curr._id] = curr;
            return acc;
        }, {}));
    }, [devices]);
    useEffect(function () {
        getData();
    }, []);
    var getDataForDateRange = function () { return __awaiter(void 0, void 0, void 0, function () {
        var promises, projectId;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            if (groupService.group && groupService.group.id && dates.length > 0) {
                promises = [
                    service.telematics
                        .getAnalyticsV2({
                        project_id: groupService.group.id,
                        start_date: (_a = dates[0]) === null || _a === void 0 ? void 0 : _a.toDate(),
                        end_date: (_b = dates[1]) === null || _b === void 0 ? void 0 : _b.toDate(),
                    })
                        .then(function (v) {
                        var e_1, _a, e_2, _b, e_3, _c;
                        setAnalyticsData(v);
                        var pieData2 = [];
                        v.top_utilized_equipments.forEach(function (item) {
                            pieData2.push({
                                x: item.label,
                                y: Number((item.utilization * 100).toFixed(1)),
                                id: item.id,
                            });
                        });
                        setMchinesDataByIgnitionOn(pieData2);
                        var pieData3 = [];
                        v.top_idle_equipments.forEach(function (item) {
                            pieData3.push({
                                x: item.label,
                                y: Number((item.idle_minutes * 100).toFixed(1)),
                                id: item.id,
                            });
                        });
                        setIdlingMachinesData(pieData3);
                        var pieData4 = [];
                        v.top_violated_equipments.forEach(function (item) {
                            pieData4.push({
                                x: item.label,
                                y: Number(item.count),
                                id: item.id,
                            });
                        });
                        setViolationsStatistics(pieData4);
                        var pieData5 = [];
                        var violation_type_map = v.violation_type_map;
                        try {
                            for (var _d = __values(Object.keys(violation_type_map)), _e = _d.next(); !_e.done; _e = _d.next()) {
                                var key = _e.value;
                                pieData5.push({
                                    x: key === 'harsh-breaking'
                                        ? 'harsh-braking'
                                        : key,
                                    y: violation_type_map[key],
                                });
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        setTotalViolations(pieData5);
                        var tableData1 = [];
                        var violationMap = v.equipment_type_violation_type_map;
                        var i = 0;
                        try {
                            for (var _f = __values(Object.keys(violationMap)), _g = _f.next(); !_g.done; _g = _f.next()) {
                                var key = _g.value;
                                tableData1.push({
                                    key: i.toString(),
                                    type: key,
                                    geoAlert: (violationMap[key]['geo-out'] || 0) +
                                        (violationMap[key]['geo-in'] || 0) +
                                        (violationMap[key]['restricted-geofence-entry'] || 0),
                                    harshDriving: (violationMap[key]['harsh-breaking'] || 0) +
                                        (violationMap[key]['harsh-cornering'] ||
                                            0) +
                                        (violationMap[key]['harsh-acceleration'] ||
                                            0),
                                    overspeed: violationMap[key]['overspeed'] || 0,
                                });
                                i++;
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        setMatrixTableData(tableData1);
                        var idleBarData = [];
                        var idleData = v.equipment_type_average_idle_minutes;
                        try {
                            for (var _h = __values(Object.keys(idleData)), _j = _h.next(); !_j.done; _j = _h.next()) {
                                var key = _j.value;
                                idleBarData.push({
                                    x: key,
                                    y: Math.round(idleData[key].average * 10) / 10,
                                });
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        setOverTimeTableData(v.top_usage_exceeded_equipments);
                    }),
                ];
                setAnalyticsLoading(true);
                Promise.all(promises)
                    .then(function () {
                    setAnalyticsLoading(false);
                })
                    .catch(function (e) { return console.error('ERROR!: ', e); });
                projectId = groupService.group.id;
                if (dates && groupService) {
                    service.safety
                        .getViolationsHeatMapCoordinates({
                        projectId: projectId,
                        startDate: (_c = dates[0]) === null || _c === void 0 ? void 0 : _c.toDate(),
                        endDate: (_d = dates[1]) === null || _d === void 0 ? void 0 : _d.toDate(),
                        type: ViolationType.Idling
                    })
                        .then(function (response) { return response; })
                        .then(function (result) {
                        setIdlingHeatmapData(result);
                        setHeatmapLoading(false);
                    })
                        .catch(function (error) { return console.error('error', error); });
                }
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        if (!dates)
            return;
        setHeatmapLoading(true);
        getDataForDateRange();
    }, [dates, groupService.group]);
    var permissions = useGroupPermissions();
    return permissions === GroupPermission.None ? (React.createElement(NoPermissionView, null)) : (React.createElement(React.Fragment, null,
        React.createElement(Content, { className: "analytics-page holder" },
            React.createElement("div", { style: { marginBottom: 24 } },
                React.createElement(DateRangeFilter, { onChange: setDates, useTimezone: true })),
            React.createElement(Row, { gutter: [16, 16], className: "stats" },
                React.createElement(ProjectStatisticsCard, { analyticsData: analyticsData, loading: loading, equipments: equipments }),
                React.createElement(LiveStatusCard, { loading: devicesTotalCount > 0 ? false : loading, equipments: equipments, devicesTotalCount: devicesTotalCount }),
                React.createElement(Col, { span: 24 },
                    React.createElement(Card, { title: 'Idling heatmap' },
                        React.createElement("div", { style: { height: '400px' } },
                            React.createElement(HEREMap, { loading: heatmapLoading },
                                React.createElement(IdlingHeatMapCard, { data: idlingHeatmapData }))))),
                React.createElement(MachineByTypeCard, { loading: loading, equipments: equipments }),
                React.createElement(BreakdownByOutcomeCard, { loading: loading }),
                React.createElement(MachineByIgnitionTurnedOnCard, { data: mchinesDataByIgnitionOn, loading: loading }),
                React.createElement(IdlingMachinesCard, { data: idlingMachinesData, loading: loading }),
                React.createElement(OvertimeStatsCard, { loading: loading, data: analyticsData, overtimeTableData: overTimeTableData }),
                (analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.total_violations) > 0 && (React.createElement(React.Fragment, null,
                    React.createElement(ViolationsStatisticsCard, { data: analyticsData, loading: loading, graphData: violationsStatistics }),
                    React.createElement(ViolationAndMachineTypeAnalyticsCard, { data: matrixTableData }),
                    React.createElement(TotalViolationsByTypeCard, { data: totalViolations }))),
                React.createElement(RecentEventsCard, { groupId: props.match.params.groupId })))));
};
export default GroupAnalyticsPage;
